import dayjs from 'dayjs';

export const useDataFormat = (data: string): string => {
    return dayjs(data).format('DD-MM-YYYY');
};

export const useDataFormatWithTime = (data: string): string => {
    return dayjs(data).format('DD-MM-YYYY HH:mm:ss');
};
